import React, { useState, useEffect } from "react";

import { storage, database } from "../firebase";

import {
  Alert,
  Button,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  ListSubheader,
  CircularProgress,
  LinearProgress,
  Stack,
} from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import AlertDialog from "./AlertDialog";

const TemplateList = ({ templateChanger, ...rest }) => {
  const [templates, setTemplates] = useState([]);
  const [error, setError] = useState(false);
  const [state, setState] = useState("");
  const [upload, setUpload] = useState("allow");

  const storageRef = storage.ref("templates");

  useEffect(() => {
    if (upload !== "allow" || templates.length) return;
    async function fetchData() {
      setState("loading");

      const res = await storageRef.listAll().catch((err) => {
        console.error("Error:", err);
        setState("error");
        setError(err);
      });
      setState("success");

      const images = await Promise.all(
        res.items.map(async (i) => ({
          url: await i.getDownloadURL(),
          metadata: await i.getMetadata(),
        }))
      );

      setTemplates(images);
    }

    fetchData();
  }, [upload, templates]);

  if (state === "error") return <h1>{error.toString()}</h1>;
  if (state === "loading") return <CircularProgress />;

  const uploadTemplate = (file) => {
    if (!file) return;

    setUpload("progress");

    const fileRef = storageRef.child(file.name);

    fileRef
      .put(file)
      .then(async (snapshot) => {
        const templateRef = database.ref(
          `templates/${snapshot._delegate.metadata.generation}`
        );

        await templateRef.set({
          items: {
            name: {
              type: "div",
              parameters: {
                centerX: true,
              },
            },
          },
        });

        setUpload("allow");
        setTemplates([]);
      })
      .catch((e) => {
        console.error(e);
        setUpload("error");
      });
  };

  return (
    <div>
      <Stack spacing={2}>
        <Button
          startIcon={<UploadFile />}
          variant="contained"
          component="label"
          disabled={!["allow", "error"].includes(upload)}
        >
          Carica
          <input
            hidden
            accept="image/*"
            type="file"
            onChange={(e) => uploadTemplate(e.target.files[0])}
          />
        </Button>
        {upload === "progress" ? (
          <LinearProgress />
        ) : upload === error ? (
          <Alert severity="error">Errore durante il caricamento del file</Alert>
        ) : (
          ""
        )}
      </Stack>
      <ImageList rowHeight={180} cols={1}>
        <ImageListItem key="Subheader" cols={1} style={{ height: "auto" }}>
          <ListSubheader component="div">Templates</ListSubheader>
        </ImageListItem>
        {templates.map((template) => (
          <ImageListItem
            key={template.url}
            cols={1}
            onClick={() => templateChanger(template)}
          >
            <img src={template.url} alt={template.metadata.name} />

            <ImageListItemBar
              title={template.title}
              subtitle={<span>{template.metadata.name}</span>}
              actionIcon={
                <AlertDialog template={template} setTemplates={setTemplates} />
              }
            />
          </ImageListItem>
        ))}
      </ImageList>
    </div>
  );
};

export default TemplateList;
